import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import VideoDetail from 'components/VideoDetail'
import { StoriesStore } from 'stores/stories'
import { ConfigStore } from 'stores/config'
import { EventsStore } from 'stores/events'
import { useStoryPageView, useStore } from 'hooks'
import { getServerSideWrapper } from 'utils/data-fetching'
import THEME from 'utils/theme'

const VideoDetailPage = ({ latestEvent, story, currentVideoSource, videoList, videoListTitle, global }) => {
  useStore(StoriesStore, { current: story, currentVideoSource, videoList })
  useStore(EventsStore, { current: latestEvent })
  useStore(ConfigStore, { current: global.config })

  useStoryPageView(story)

  return (
    <SiteLayout background={THEME.COLORS.BACKGROUND_GRAY} showNavBarCTA useAvailableEventLogo={false}>
      <Head story={story} videoSource={currentVideoSource} />
      <VideoDetail title={videoListTitle} />
    </SiteLayout>
  )
}

export const getServerSideProps = getServerSideWrapper(async ({ params }) => {
  const { id } = params
  const [story, currentVideoSource, latestEvents, videoList] = await Promise.all([
    StoriesStore().findById(id),
    StoriesStore().findVideoSource(id),
    EventsStore().findRNR(),
    StoriesStore().findVideoList()
  ])

  return {
    latestEvent: latestEvents?.[0] || null,
    story,
    currentVideoSource,
    videoList,
    videoListTitle: 'Latest Videos'
  }
})

export default VideoDetailPage
